<template>
  <div class="chat-window">
    <div
      ref="messagesContainer"
      class="messages"
      v-chat-scroll="{ always: false, smooth: true, scrollonremoved: true }"
    >
      <ChatMessageItem
        v-for="message in messages"
        v-bind:key="message.id"
        v-bind:message="message"
        v-bind:current-user-id="currentUserId"
        v-bind:show-private-button="showPrivateButton"
        v-on:reply="$emit('reply', $event)"
        v-on:private-chat="$emit('private-chat', $event)"
      />
      <p v-if="messages.length === 0" class="empty">Сообщений пока нет</p>
    </div>

    <div v-if="replyTo" class="reply-bar">
      <span>
        Ответ @{{ replyTo.user.username }}:
        {{ truncate(replyTo.body) }}
      </span>
      <button type="button" class="delete is-small" v-on:click="$emit('cancel-reply')" />
    </div>

    <form class="input-row" v-on:submit.prevent="submit">
      <input
        ref="input"
        class="input is-small"
        type="text"
        placeholder="Сообщение…"
        v-model="draft"
        v-on:keydown.esc="$emit('cancel-reply')"
      />
      <button
        type="submit"
        class="button is-small is-link"
        v-bind:disabled="!draft.trim() || sending"
      >
        Отправить
      </button>
    </form>
  </div>
</template>

<script>
import ChatMessageItem from './ChatMessageItem'

export default {
  components: { ChatMessageItem },
  props: {
    messages: {
      type: Array,
      default: () => [],
    },
    replyTo: {
      type: Object,
      default: null,
    },
    sending: {
      type: Boolean,
      default: false,
    },
    currentUserId: {
      type: String,
      default: null,
    },
    showPrivateButton: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      draft: '',
    }
  },
  methods: {
    submit () {
      const body = this.draft.trim()
      if (!body || this.sending) return
      this.$emit('send', body)
      this.draft = ''
    },
    truncate (text) {
      if (!text) return ''
      return text.length > 60 ? `${text.slice(0, 60)}…` : text
    },
    focusInput () {
      this.$refs.input?.focus()
    },
  },
}
</script>

<style scoped>
.chat-window {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
}

.messages {
  flex: 1;
  overflow-y: auto;
  min-height: 0;
  background: #fafafa;
  border: 1px solid #ededed;
  border-radius: 4px;
}

.empty {
  padding: 1rem;
  color: #999;
  text-align: center;
  font-size: 0.85rem;
}

.reply-bar {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.35rem 0.5rem;
  background: #f5f5f5;
  font-size: 0.8rem;
  border-radius: 4px;
  margin-top: 0.35rem;
}

.input-row {
  display: flex;
  gap: 0.5rem;
  margin-top: 0.35rem;
}

.input-row .input {
  flex: 1;
}
</style>
